import { MutableRefObject, useEffect } from 'react';

import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';

import { sleeper } from '@sbv-clients/util-misc';

export const useDataGridToggleExpansion = (
  allowed: boolean,
  apiRef: MutableRefObject<GridApiPremium>
) => {
  useEffect(() => {
    if (!allowed) {
      return;
    }
    sleeper(100).then(() => {
      apiRef.current.getAllRowIds().forEach((id) => {
        apiRef.current.toggleDetailPanel(id);
      });
    });
  }, [apiRef, allowed]);
};

export default useDataGridToggleExpansion;
